export interface SuggestedMember {
  id: string;
  name: string;
  role: string;
  company: string;
  location: string;
  bio: string;
  coverImage: string;
  avatar: string;
}

export const mockSuggestedMembers: SuggestedMember[] = [
  {
    id: "1",
    name: "Lucas Wilde",
    role: "Chief Technology Officer",
    company: "TechVenture Capital",
    location: "San Francisco, CA",
    bio: `Lucas Wilde is a visionary technology leader with over 15 years of experience driving innovation in the venture capital space. As Chief Technology Officer at TechVenture Capital, he has been instrumental in identifying and nurturing groundbreaking startups in AI, fintech, and enterprise software.

His expertise lies in evaluating technical teams, assessing product-market fit, and helping portfolio companies scale their engineering organizations. Lucas has a unique ability to bridge the gap between technical depth and business strategy, making him a sought-after advisor for both founders and investors.

Before joining TechVenture Capital, Lucas co-founded two successful SaaS companies that were later acquired by Fortune 500 companies. His hands-on experience as a founder gives him deep empathy for the challenges entrepreneurs face, while his technical background allows him to make informed investment decisions in complex technology sectors.`,
    coverImage: "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86",
    avatar: "ec5f761f-10c3-4113-b292-b2d34d0a4558"
  },
  {
    id: "2",
    name: "Aiden Parker",
    role: "Marketing Chief",
    company: "Growth Partners",
    location: "New York, NY",
    bio: `Aiden Parker brings a data-driven approach to marketing strategy, having built and scaled marketing teams for some of the fastest-growing companies in the consumer and B2B sectors. As Marketing Chief at Growth Partners, Aiden helps portfolio companies develop go-to-market strategies that accelerate revenue growth.

With a background spanning both agency and in-house roles, Aiden understands the full spectrum of marketing challenges—from brand positioning to performance marketing optimization. He's particularly known for his work in building sustainable growth engines that don't rely solely on paid acquisition.

Aiden's expertise includes brand development, content strategy, community building, and marketing automation. He's helped multiple companies achieve 10x growth in their customer base while maintaining healthy unit economics. His practical, results-oriented approach makes him a valuable advisor for companies at any stage of growth.`,
    coverImage: "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86",
    avatar: "9b5a54b5-bcc7-449d-9935-448e9b3e41fc"
  },
  {
    id: "3",
    name: "Nora Hayes",
    role: "Lead of Innovation",
    company: "Future Ventures",
    location: "Boston, MA",
    bio: `Nora Hayes is a forward-thinking innovation leader who specializes in identifying emerging trends and helping companies adapt to rapidly changing markets. As Lead of Innovation at Future Ventures, she focuses on sectors including healthcare technology, climate tech, and the future of work.

Nora's career has been defined by her ability to see around corners—anticipating market shifts before they become mainstream. She has a particular talent for connecting seemingly disparate trends to identify new investment opportunities and help portfolio companies pivot when necessary.

Her background includes roles in product management, corporate strategy, and venture capital, giving her a holistic view of how innovation happens at different stages of company development. Nora is passionate about supporting diverse founders and has been a vocal advocate for increasing representation in venture capital and entrepreneurship.`,
    coverImage: "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86",
    avatar: "b18cb277-e1b9-43ae-8463-d6afc5c9cd8d"
  },
  {
    id: "4",
    name: "Ethan Brooks",
    role: "Head of Technology",
    company: "Digital Capital Partners",
    location: "Seattle, WA",
    bio: `Ethan Brooks combines deep technical expertise with strategic business acumen, making him a unique asset in the venture capital ecosystem. As Head of Technology at Digital Capital Partners, he evaluates technical teams, conducts technical due diligence, and helps portfolio companies build world-class engineering organizations.

With a computer science background and experience as both an engineer and engineering leader, Ethan understands the technical challenges that startups face at every stage. He's particularly skilled at helping companies make critical technology decisions—from choosing the right tech stack to scaling infrastructure to support rapid growth.

Ethan has been involved in the technology community for over two decades, having worked at both startups and large tech companies before transitioning to venture capital. His network of engineering talent and his understanding of technical trends make him an invaluable resource for the companies he works with.`,
    coverImage: "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86",
    avatar: "c5c752f5-5ffd-4b3b-9f00-25870da1fcd1"
  },
  {
    id: "5",
    name: "Lynda Smith",
    role: "Executive Business Advisory",
    company: "Overwatch Capital",
    location: "New York, NY",
    bio: `Lynda Smith brings decades of strategic leadership to Overwatch Capital, where she serves as Executive Business Advisory. Known for her ability to connect vision with execution, Lynda has built a career at the intersection of aerospace innovation, transformative technology, and social impact.

Raised with a fascination for flight and exploration, she began her career in aerospace engineering, working with leading space agencies and private companies during the formative years of commercial space travel. Her early work helped shape partnerships between governments and the private sector, paving the way for breakthroughs in satellite technology and orbital infrastructure. This foundation gave her a unique lens on how bold innovation can be scaled into sustainable industries.`,
    coverImage: "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86",
    avatar: "e64ab4db-1340-4d15-96dd-3c9121196b86"
  }
];

